module.exports = __webpack_public_path__ + "0dfce4b016c7f7347310a5386bcbb42a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-1024.jpg
// module id = 242
// module chunks = 0